import { render, staticRenderFns } from "./DatabaseSelect.vue?vue&type=template&id=8e0381c8"
import script from "./DatabaseSelect.vue?vue&type=script&lang=js"
export * from "./DatabaseSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports